import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import AzurePlanUsageCSP from "../../../models/csp/AzurePlanUsageCSP";
import SubscriptionCSP from "../../../models/csp/SubscriptionCSP";
import azurePlanUsageService from "../../../services/csp/azurePlanUsageService";
import subscriptionService from "../../../services/csp/subscriptionService";
import { RootState } from "../../index";

const namespaced = true;

const normalizeResourceGroupName = (resourceGroupName: string): string =>
  resourceGroupName.trim().toLowerCase();

interface AzurePlanUsageState {
  azurePlansUsages: AzurePlanUsageCSP[];
}

const state: AzurePlanUsageState = {
  azurePlansUsages: []
};

const mutations: MutationTree<AzurePlanUsageState> = {
  setAzurePlansUsages(state, azPlansUsages: AzurePlanUsageCSP[]) {
    state.azurePlansUsages = azPlansUsages;
  }
};

const actions: ActionTree<AzurePlanUsageState, RootState> = {
  async loadAzurePlansUsagesCSP({ commit }, customerId: string) {
    const azPlansUsages: AzurePlanUsageCSP[] = [];
    const azPlans: SubscriptionCSP[] =
      await subscriptionService.methods.getAzurePlanIdsByTenantId(customerId);
    for (const azPlan of azPlans) {
      const azPlanUsages: AzurePlanUsageCSP[] =
        await azurePlanUsageService.methods.getAzurePlanUsagesCSP(
          customerId,
          azPlan.getId
        );
      azPlansUsages.push(...azPlanUsages);
    }
    commit("setAzurePlansUsages", azPlansUsages);
  }
};

const getters: GetterTree<AzurePlanUsageState, RootState> = {
  getAzurePlanUsagesCSPByAzurePlanId:
    state =>
    (azPlanId: string): AzurePlanUsageCSP[] => {
      return state.azurePlansUsages.filter(
        azUsage => azUsage.getAzurePlanId === azPlanId
      );
    },
  getAzurePlanUsagesCSPByEntitlementId:
    state =>
    (entitlementId: string): AzurePlanUsageCSP[] => {
      return state.azurePlansUsages.filter(
        azUsage => azUsage.getEntitlementId === entitlementId
      );
    },
  getAzurePlanUsagesCSPByResourceGroupName:
    state =>
    (resourceGroupName: string): AzurePlanUsageCSP[] => {
      return state.azurePlansUsages.filter(
        azUsage =>
          normalizeResourceGroupName(azUsage.getResourceGroupName) ===
          normalizeResourceGroupName(resourceGroupName)
      );
    }
};

export const azurePlanUsageModuleCSP: Module<AzurePlanUsageState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
